import { Colors, Lightning, Router, Utils } from '@lightningjs/sdk';
import { Column } from '@lightningjs/ui-components';

export default class LoginIn extends Lightning.Component {
  static _template() {
    return {
      Background: {
        w: 1920,
        h: 1080,
        texture: Lightning.Tools.getSvgTexture(Utils.asset('images/background.png'), 1920, 1080),
      },
      Logo: {
        x: 220,
        y: 235,
        texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 470, 67),
      },
      Title: {
        x: 220,
        y: 355,
        w: 682,
        h: 95,
        text: {
          text: 'Unlimited clean inspiring shows for all. Watch anywhere, cancel anytime.',
          textColor: Colors('#fafafa').get(),
          fontFace: 'OpenSans-SemiBold',
          fontSize: 36,
          lineHeight: 48,
        },
      },
      BtnContainer: {
        collision: true,
        x: 220,
        y: 500,
        w: 244,
        h: 61,
        rect: true,
        type: Column,
        color: Colors('#707070').get(),
        shader: { type: Lightning.shaders.RoundedRectangle, radius: 12 },
        LogInBtn: {
          type: Column,
          Text: {
            y: 12,
            x: 81,
            text: {
              text: 'Log In',
              textColor: Colors('#ffffff').get(),
              fontFace: 'OpenSans-SemiBold',
              fontSize: 28,
              lineHeight: 34,
            },
          },
        },
      },
    };
  }

  get id() {
    return 'LoginPage';
  }

  get _LogInBtn() {
    return this.tag('BtnContainer.LogInBtn');
  }

  _firstEnable() {
    this._setState('LogInBtn');
    this._LogInBtn.patch({
      texture: Lightning.Tools.getRoundRect(240, 59, 11, 4, Colors('#02AC25').get(), false),
    });
  }

  _handleHover() {
    this._focus();
  }

  _handleClick() {
    this._handleEnter();
  }

  _handleEnter() {
    Router.navigate('login-online');
  }
}
